<template>
	<div class='public-profile-page__profile-link'>
		<div class='profile-row'>
			<div class='user-name'>
				{{ value.name }}
			</div>
			<a href='/profile/' class='icon' v-if='profile.id===value.id'>
				<svg class='icon'>
					<use xlink:href='#icon-edit'/>
				</svg>
			</a>
		</div>

		<div class='userAvatarContainer'>
			<a v-if='value.photo_big' :href='`/profile/${value.id}`' class='avatar'>
				<img :src='value.photo_big'>
				<div class='agent-icon agent-icon-md' v-if='value.type==="agent"'>
					<icon icon-name='agent'/>
				</div>
			</a>
		</div>
		<button v-if='profile.id!==value.id && value.type==="agent"'
			class="btn follow-btn waves-effect waves-light"
			:class="{'follow-btn--cancel':value.is_followed}"
			@click='toggleFollow'>
			<svg v-if="!value.is_followed"
				class="follow-btn__icon"
				width="27"
				height="20"
				viewBox="0 0 27 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M16.4648 19V17C16.4648 15.9391 16.0434 14.9217 15.2933 14.1716C14.5431 13.4214 13.5257 13 12.4648 13H5.46484C4.40398 13 3.38656 13.4214 2.63642 14.1716C1.88627 14.9217 1.46484 15.9391 1.46484 17V19"
					stroke="white"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"/>
				<path
					d="M8.96484 9C11.174 9 12.9648 7.20914 12.9648 5C12.9648 2.79086 11.174 1 8.96484 1C6.7557 1 4.96484 2.79086 4.96484 5C4.96484 7.20914 6.7557 9 8.96484 9Z"
					stroke="white"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"/>
				<path d="M22 4.96448V12.0355"
					stroke="white"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"/>
				<path d="M25.5355 8.50001H18.4645"
					stroke="white"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"/>
			</svg>
			<svg v-else
				class="follow-btn__icon"
				width="25"
				height="20"
				viewBox="0 0 25 20"
				fill="none"
				xmlns="http://www.w3.org/2000/svg">
				<path
					d="M16.5 19V17C16.5 15.9391 16.0786 14.9217 15.3284 14.1716C14.5783 13.4214 13.5609 13 12.5 13H5.5C4.43913 13 3.42172 13.4214 2.67157 14.1716C1.92143 14.9217 1.5 15.9391 1.5 17V19"
					stroke="#DA3B26"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"/>
				<path
					d="M9 9C11.2091 9 13 7.20914 13 5C13 2.79086 11.2091 1 9 1C6.79086 1 5 2.79086 5 5C5 7.20914 6.79086 9 9 9Z"
					stroke="#DA3B26"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"/>
				<path d="M18.5 6L23.5 11"
					stroke="#DA3B26"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"/>
				<path d="M23.5 6L18.5 11"
					stroke="#DA3B26"
					stroke-width="2"
					stroke-linecap="round"
					stroke-linejoin="round"/>
			</svg>

			{{ followBtnLabel }}
		</button>
		<div class='markets' v-if='value.major_market && value.major_market.id'>
			<div class='title-1'>
				Major Market
			</div>
			<a class='market-green-1' :href='`/markets/${value.major_market.id}`'>
				{{ value.major_market.name }}<span v-if='region'>, {{ value.major_market.region.name }}</span>
			</a>
		</div>
		<div class='markets' v-if='value.sub_market && value.sub_market.id'>
			<div class='title-1'>
				Sub-Market
			</div>
			<a class='market-green-1' :href='`/markets/${value.sub_market.id}`'>
				{{ value.sub_market.name }}<span v-if='region'>, {{ value.sub_market.region.name }}</span>
			</a>
		</div>
		<div class='markets' v-if='value.email && (profile.type === "agent" || profile.type === "listed_agent")'>
			<div class='title-1'>
				Email me:
			</div>
			<a class='market-green-1' :href='`mailto:${value.email}`'>
				{{ value.email }}
			</a>
		</div>
		<div class='markets' v-if='value.profile_type && value.profile_url && (profile.type === "agent" || profile.type === "listed_agent")'>
			<div class='title-1'>
				Connect me online:
			</div>
			<a class='market-green-1 connect-link'
				:href='value.profile_url'
				v-if='value.profile_type=="instagram"'
				target='_blank'
			>
				<img src='/assets/img/instagram.png'> <span>{{ value.profile_url.replace('https://', '') }}</span>
			</a>
			<a class='market-green-1 connect-link'
				:href='value.profile_url'
				v-else-if='value.profile_type=="facebook"'
				target='_blank'
			>
				<img src='/assets/img/facebook.png'> <span>{{ value.profile_url.replace('https://', '') }}</span>
			</a>
			<a class='market-green-1 connect-link'
				:href='value.profile_url'
				v-else-if='value.profile_type=="linkedin"'
				target='_blank'
			>
				<img src='/assets/img/linkedin.png'> <span>{{ value.profile_url.replace('https://', '') }}</span>
			</a>
			<a class='market-green-1 connect-link'
				:href='value.profile_url'
				v-else-if='value.profile_type=="twitter"'
				target='_blank'
			>
				<img src='/assets/img/twitter.png'> <span>{{ value.profile_url.replace('https://', '') }}</span>
			</a>
			<a class='market-green-1 connect-link'
				:href='value.profile_url'
				v-else
				target='_blank'
			>
				<span>{{ value.profile_url.replace('https://', '') }}</span>
			</a>
		</div>

		<div class='markets' v-if='value.phone && (profile.type === "agent" || profile.type === "listed_agent")'>
			<div class='title-1'>
				Call Me
			</div>
			<a class='market-green-1' :href='`tel:+ ${value.phone}`'>
				{{ value.phone }}
			</a>
		</div>
		<div class='markets' v-if='value.about'>
			<div class='title-1'>
				About Me:
			</div>
			<div class='market-black'>
				<pre>{{ value.about }}</pre>
			</div>
		</div>
		<div class='sidebar-title-container followers-title' v-if='value.followers?value.followers.length:false'>
			<span class='sidebar-header'>
				<span>Followers</span>
				<!-- <span v-if='value.followers.length>=4' class='see_all' @click='redirectToAllFollowers'>See all</span> -->
				<span class='see_all' @click='redirectToAllFollowers'>See all</span>
			</span>
		</div>
		<ListOfPersonsMin
			class='title-sm'
			:value='value.followers'
		/>
	</div>
</template>

<script>
import icon from '__jsVueUI/icon.vue';
import api from '__jsVueApi';
import ListOfPersonsMin from '__jsVueSections/ListOfPersonsMin/ListOfPersonsMin.vue';

export default {
	name:  'ProfileSidebar',
	props: {
		value: {
			type: Object
		},
		region: {
			type:    Boolean,
			default: false
		},
	},
	components: {
		icon,
		ListOfPersonsMin
	},
	methods: {
		async toggleFollow() {
			await axios.post(api.publicProfile.toggleFollow(this.value.id)).then((response) => {
				this.$emit('update');
			});
		},
		redirectToAllFollowers() {
			window.location.href = `/profile/${this.value.id}/followers/`;
		},
	},
	computed: {
		followBtnLabel() {
			if (this.value.is_followed) {
				return 'Unfollow';
			}
			return 'Follow';
		},
		profile() {
			return this.$store.state.profile.profile;
		},
	},
};
</script>

<style lang="scss">
.follow-btn {
	width: 100%;
	margin-top: 20px;

	&--cancel {
		background-color: #fff;
		color: #da3b26;
		border-color: #e2e2e5;

		&:hover {
			background-color: #fff;
			border-color: #da3b26;
		}
	}

	&__icon {
		margin-right: 8px;
	}
}
</style>
